/**
 * @file Billing.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Request from '../components/http/request'
import Service from './Service'
import Vue from "vue";

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * Billing Management Service
 * @class
 */
class Billing extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'das'})
  }

  /**
     * Get data based on the layer or user template
     *
     * @async
     * @function Get data based on the layer or user template
     * @param {int} environmentId Environment identifier
     * @param {string} clientTag The client tag
     * @return {json} The json with the result
     */
async getDetails(environmentId, clientTag) {
  return new Promise((resolve, reject) => {
    try {
      // Obtendo o token do usuário
      defaultJsonHeaders.headers['Authorization-DataLead'] = Vue.prototype.$foundation.getUserToken();

      // Definindo o endpoint correto
      let endPoint = `/billing/details?env_id=${environmentId}&client_tag=${clientTag}`;

      // Fazendo a requisição HTTP
      let req = new Request({ tag: 'python'})
      req.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(error => {
          console.error("Erro na requisição getDetails:", error);
          reject(error); // Agora rejeita corretamente com o erro capturado
        });

    } catch (error) {
      console.error("Erro inesperado em getDetails:", error);
      reject(error);
    }
  });
}






  /**
   * Get data based on the layer or user template
   *
   * @async
   * @function Get data based on the layer or user template
   * @param {int} userId User identifier
   * @param {int} environmentId Environment identifier
   * @param {int} layerId Layer identifier
   * @param {string} classType The template class type
   * @param {boolean} confirmed The purchase has confirmed or accepted
   * @param awaitFinish Await for finish process
   * @return {Promise<json>} The json with the result
   */
  async purchase (userId, environmentId, layerId, classType = 'grid', confirmed = false, awaitFinish = false) {
    return new Promise((resolve, reject) => {
      defaultJsonHeaders.headers['Authorization-DataLead'] = Vue.prototype.$foundation.getUserToken()
      let endPoint = `/api/0.1-a/billing/purchase/${userId}/${environmentId}/${layerId}/${classType}?confirmed=${confirmed}&awaitFinish=${awaitFinish}`;
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get billing column tick
   *
   * @async
   * @function getTick
   * @param {string} table - Table name
   * @return {Promise<json>} The json with the result
   */
  async getTick(table) {
    return new Promise((resolve, reject) => {
      if (typeof table === 'undefined') reject("Esperado o nome da tabela");
      let endPoint = `/api/0.1-a/Billing/Tables?cObjectTag=${table}`;
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
}

export { Billing }
